import { Carousel } from "react-responsive-carousel";

import variables from "../../styles/variables.module.scss";
import styles from "./home.module.scss";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { useT } from "../../i18n";

const Slider = () => {
  const t = useT();
  return (
    <div className={`${styles.slider} ${variables.row}`}>
      <span className={variables.title}>{t("home.partners")}</span>
      <Carousel autoPlay showThumbs={false} infiniteLoop>
        <div>
          <img src={"/dimac.avif"} alt="Dimac ler" />
        </div>
        <div>
          <img src={"/mek.avif"} alt="Mek" />
        </div>
        <div>
          {/* card.jpg still exists as the og:image — social crawlers can't
              read AVIF — but the browser gets the lighter twin. */}
          <img src={"/card.avif"} alt="logo" />
        </div>
      </Carousel>
    </div>
  );
};

export default Slider;
